import { render, staticRenderFns } from "./BrowseList.vue?vue&type=template&id=f9924ae8&scoped=true&"
import script from "./BrowseList.vue?vue&type=script&lang=js&"
export * from "./BrowseList.vue?vue&type=script&lang=js&"
import style0 from "./index.css?vue&type=style&index=0&id=f9924ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9924ae8",
  null
  
)

export default component.exports